export const VERIFY_URL = `${window.ENV.HTTP_URL}/supplier/verify`
